<template>
 <b-container class="container">
   <div v-if="signed_in">
     <div style="margin: 0.5rem 0;">
        You are signed in as {{ $parent.currentUser.email }}
     </div>
     <b-button variant="danger"
        size="sm"
        @click='$parent.signUserOut(null,"Signing you out","danger")'>
        Sign Out
     </b-button>
   </div>
   <div v-if="!signed_in">
     <h3>You're not signed in</h3>
     <b-button variant="success" :to="{name: 'login'}">Sign in</b-button>
   </div>


   <div>
     <b-button variant="primary"
       v-if="is_adm"
       @click="createEvent"
     > Create Event
     </b-button>
     <h2>Events You Can Edit</h2>
     <b-card-group deck
       v-if="events && events.length">
       <b-card  v-for="event in events"
         :title="event.name" sub-title="" class="eventman_card"
         :img-src="event.banner"
         img-width="150" img-height="200">
         <b-card-text class="para">
            {{ utils.abridgeDescr(event) }}
         </b-card-text>
         <b-button :to="{ name:'manage_event', params: { id: event.id }}"
           variant="primary">
           Manage Event
         </b-button>
         <b-button :to="{ name:'event', params: { id: event.id }}"
           variant="primary">
           Preview Event
         </b-button>
      </b-card> 
     </b-card-group>
     <div v-if="!events || !events.length">
        There are no events for which you are authorized to change.
     </div>
   </div>

   <div style="position:fixed;bottom:0;left:0.5rem;font-size:0.8rem;">
     {{ version }}
   </div>  
  </b-container>
</template>

<script>

import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";

export default {
  name: "eventmanager",
  data() {
    return {
      utils: utils,
      version: "",
      events: [],
      signed_in: true,
      is_adm: null,
    }
  },
  components: {
  },
  created() {
  },
  methods: {
     createEvent: function() {
       window.wss_send(vx, "adm_event_set", {rtag:"eventmanager",
         event: {
            ver: 1,
            name: "New Event",
            banner: 'https://images.freeimages.com/images/large-previews/1ce/stars-1194599.jpg',
         }
       });
     }
  },
  computed: {
  },
  beforeDestroy() {
     window.wss_clr_routes(window.vx,"eventmanager");
  },
  mounted() {
    $("body").removeClass("setbackground");
    let vue = this;
    vue.version = vx.about.site_version;
    if (!vx.user) {
	console.log("no vx.user");
        vue.signed_in = false;
	return;
    }

    vue.is_adm = false;
    if (vx.acc == vue.$router.currentRoute.params.acc &&
        vue.$parent.currentUser.adm_acc) {
        vue.is_adm = true;
    }

    window.wss_open(vx, {
      acc: vue.$router.currentRoute.params.acc,
      uid: vx.user.id,
      routes_id: "eventmanager",
      routes: {
        auth_me: function(msg){
           if (msg.data.error) {
              return;
           }
           window.wss_send(vx, "adm_event_list", {rtag: "eventmanager",
           });
        },
        // Various handlers here depending on need
        adm_event_list: function(msg) {
	   if (msg.rtag != "eventmanager") return;
	   console.log("events",msg.data.events.length);
           let events = [];
           msg.data.events.forEach(function(ev) {
              if (!ev.can_edit) { return; }
              events.push(utils.remote_to_local(ev));
           });
           vue.events = events;
 	},
	adm_event_set: function(msg) {
	   if (msg.data.error) {
              console.log("event creation failed");
              return;
           }
           let ev = msg.data.event;
           vue.$router.push({name:'manage_event',params:{id:ev.id}});
	},
      }
    });
  },
};
</script>

<style>
.container {
  background: white;
  max-width: 960px;
  padding-top: 20px;
}
.eventman_card {
  min-width: 20rem;
  max-width: 30rem;
  min-height: 20rem;
  max-height: 40rem;
  margin-top: 10px;
  margin-bottom: 10px;
}

.date_time {
  font-size:1.2rem;
  font-weight:500;
  text-align:left;
  color:black;
  padding-bottom: 1rem;
}
.para {
  white-space:pre-wrap;
}
</style>
